
import { A2AMessage, A2AAgent } from '../types';

export enum CommunicationType {
  COORDINATION = 'COORDINATION',
  DATA_SHARING = 'DATA_SHARING',
  NEGOTIATION = 'NEGOTIATION',
  VALIDATION = 'VALIDATION',
  QUESTION = 'QUESTION'
}

export function createPeerChannel(
  fromAgent: string,
  toAgent: string,
  type: CommunicationType,
  content: string,
  metadata?: Record<string, any>
): A2AMessage {
  return {
    id: `p2p-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
    fromAgent,
    toAgent,
    content,
    timestamp: new Date(),
    signature: '',
    keyId: '',
    metadata: {
      protocol: 'A2A',
      version: '1.0',
      messageType: 'P2P_COMMUNICATION',
      communicationType: type,
      bypassOrchestrator: true,
      ...metadata
    }
  };
}

// Define the type for the sendDirectMessage parameter to ensure it's used correctly
export type SendDirectMessageParams = {
  fromAgent: string;
  toAgent: string;
  content: string;
  metadata?: Record<string, any>;
};

// The sendDirectMessage function with the correct signature - accepting a single object parameter
export function sendDirectMessage(
  message: SendDirectMessageParams
): A2AMessage {
  return {
    id: `p2p-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
    fromAgent: message.fromAgent,
    toAgent: message.toAgent,
    content: message.content,
    timestamp: new Date(),
    signature: '',
    keyId: '',
    metadata: {
      protocol: 'A2A',
      version: '1.1',
      messageType: 'P2P_COMMUNICATION',
      bypassOrchestrator: true,
      ...message.metadata
    }
  };
}

export function findBestPeerForCapability(
  fromAgent: string,
  capability: string,
  availableAgents: A2AAgent[]
): A2AAgent | null {
  // Find agents with the required capability
  const candidateAgents = availableAgents.filter(agent => 
    agent.id !== fromAgent && 
    agent.isAvailable && 
    agent.capabilities.includes(capability)
  );
  
  if (candidateAgents.length === 0) {
    return null;
  }
  
  // In a real implementation, we would use historical performance data
  // For now, just return the first available agent with the capability
  return candidateAgents[0];
}

export function getAgentConnectionNetwork(): Record<string, string[]> {
  // In a production system, this would return the actual connection graph
  // For now, return a simple placeholder network
  return {
    'executive-agent': ['recruiting-agent', 'scheduling-agent', 'analytics-agent'],
    'recruiting-agent': ['sourcing-agent', 'screening-agent'],
    'scheduling-agent': ['executive-agent']
  };
}
